import React from "react";

import { TextField, makeStyles, alpha } from "../helper";

const useStyles = (searchColor) =>
  makeStyles((theme) => ({
    textField: {
      fontSize: "12px !important",
      width: "100%",
      [`& fieldset`]: {
        borderRadius: theme.spacing(4),
        border: searchColor && "1px solid rgba(226, 19, 110, 1)",
        background: searchColor && "rgba(226, 19, 110, 0.04)",
      },

      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        background: "white",
        padding: 4,
        borderRadius: 5,
        transform: "translate(14px, -11px) scale(.9)",
        fontSize: "12px !important",
        color: searchColor && "rgba(226, 19, 110, 1)",
      },

      "& .MuiInputBase-root": {
        "& .MuiOutlinedInput-notchedOutline": {
          "& legend": {
            maxWidth: 0,
          },
        },
      },
    },
    textFieldInput: {
      fontSize: "12px !important",
      color: theme.palette.primary.main,
      minHeight: 20,
      borderRadius: "32px !important",
      background: "white !important",
    },
    textFieldLabel: {
      color: alpha(theme.palette.primary.main, 0.9),
      textAlign: "initial",
      fontSize: "14px !important",
      margin: 0,
      fontFamily: "Nunito",
    },
  }));

export default function ChallanBaseInput({
  value,
  endAdornment,
  startAdornment,
  searchColor,
  ...rest
}) {
  const classes = useStyles(searchColor)();

  return (
    <TextField
      value={value || ""}
      margin="normal"
      fullWidth
      autoComplete="off"
      className={classes.textField}
      InputLabelProps={{
        className: classes.textFieldLabel,
        shrink: true,
      }}
      InputProps={{
        startAdornment: startAdornment,
        endAdornment: endAdornment,
        classes: {
          input: classes.textFieldInput,
        },
      }}
      {...rest}
    />
  );
}
